export default __webpack_public_path__ + "static/media/Mersey_Maritime.69999f70.png";